<template>
  <div class="members-grid members-grid--item">
    <!--    <div class="truncate">{{ user.user.name || user.user.username || '–' }}</div>-->
    <div class="truncate">{{ user.user.email }}
      <span v-if="user.user.username">/ </span>
      <span class="text-text-ternary" v-if="user.user.username">{{ user.user.username }}</span>
    </div>
    <div class="flex items-center">
      <template v-if="displayRoleAsText">
        {{ role.name }}
      </template>
      <ChangeUserRole v-else
                      :role="role"
                      :user-id="user.id"
                      :roles-list="rolesList"
                      @applyRole="updateUserRole"/>
      <IconInfo class="text-border-hover ml-4 outline-none"
                v-tooltip="{content: roleTooltip, classes: '--white role-tooltip-popover'}"/>
    </div>
    <div v-if="!displayRoleAsText">
      <UnlinkUserBtn :user-id="user.id"/>
    </div>
  </div>
</template>

<script>
import IconTrash from "@/components/icons/IconTrash";
import BaseSelect from "@/components/UI/BaseSelect/BaseSelect";
import {mapActions, mapGetters, mapState} from "vuex";
import IconInfo from "@/components/icons/IconInfo";
import ChangeUserRole from "@/components/cabinet/SpaceSettings/AccessSettings/AccessUsersList/ChangeUserRole";
import UnlinkUserBtn from "@/components/cabinet/SpaceSettings/AccessSettings/AccessUsersList/UnlinkUserBtn";

export default {
  name: "AccessUserListItem",
  components: {UnlinkUserBtn, ChangeUserRole, IconInfo, BaseSelect, IconTrash},
  props: {
    user: {
      type: Object,
      required: true
    },
  },
  data() {
    return {
      role: null,
    }
  },
  computed: {
    ...mapState('space', ['current_space']),
    ...mapState('cabinet/user', ['user_info']),
    ...mapGetters('cabinet/constants', ['getConstantList']),
    ...mapGetters('space', ['spaceUserRole', 'currentUserIsWatcher', 'currentUserIsUser']),
    displayRoleAsText() {
      return this.userIsCreator
          || this.userItSelf
          || this.currentUserIsWatcher
          || this.currentUserIsUser;
    },
    userIsCreator() {
      return this.current_space.data.creator_id === this.user.user.id;
    },
    userItSelf() {
      return this.user.user.id === this.user_info.data.id;
    },
    rolesList() {
      return this.getConstantList('member_role')
    },
    roleTooltip() {
      if (!this.role) return ''
      if (this.userIsCreator) return this.$t('creatorTip', {name: this.user.user.name || this.user.user.username})
      switch (+this.role.id) {
        case 0:
          return this.$t('roleViewerTip')
        case 1:
          return this.$t('roleUserTip')
        case 2:
          return this.$t('roleAdminTip')
      }
    }
  },
  methods: {
    ...mapActions('space/access', ['unlinkUserFromSpace']),
    updateUserRole() {
      this.role = this.rolesList.find(item => +item.id === this.user.role)
    }
  },
  created() {
    this.role = this.rolesList.find(item => +item.id === this.user.role)
  },
  i18n: {
    messages: {
      en: {
        creator: 'Creator',
        creatorTip: '{name} created this workspace. It cannot be downgraded or removed.',
        roleViewerTip: 'The viewer will only be able to view your data.',
        roleUserTip: 'The user cannot delete the workspace or invite members.',
        roleAdminTip: 'The administrator will be able to delete this workspace and invite other members.',
      },
      ru: {
        creator: 'Владелец',
        creatorTip: '{name} создал это пространство. Его нельзя понизить или удалить.',
        roleViewerTip: 'Наблюдатель сможет только посмотреть ваши данные.',
        roleUserTip: 'Пользователь не может удалить пространство и приглашать участников.',
        roleAdminTip: 'Администратор сможет удалить пространство и пригласить других участников.',
      }
    }
  }
}
</script>

<style lang="scss">
.members-grid--item {
  .icon-btn {
    @apply flex items-center justify-center text-text-ternary
    border border-border rounded transition duration-200 cursor-pointer;
    width: 26px;
    height: 26px;


    &:hover {
      @apply bg-red-hover text-white border-red-hover;
    }
  }

  .v-popover ::v-deep .select .multiselect {
    width: 173px;
  }
}

.tooltip.--white.role-tooltip-popover {
  @apply text-md;
  max-width: 23rem;

  .tooltip-inner {
    padding: 12px;
  }
}
</style>